<app-main-content-card>
  <div class="title-bar d-flex justify-content-between align-items-center">
    <h1>
      {{ "ADMINS.TITLE.TITLE" | translate }}
    </h1>
    <button
      mat-raised-button
      color="primary"
      [routerLink]="'/account/users/creation'"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <mat-icon>add</mat-icon>
      {{ "ADMINS.BTN.ADD" | translate }}
    </button>
  </div>

  <br />

  <ng-container *ngIf="(isTableLoading$ | async) !== true">
    <div *ngFor="let admin of merchantAdmins$ | async">
      <app-user-card
        [id]="admin.id ?? ''"
        [firstName]="admin.firstName ?? ''"
        [lastName]="admin.lastName ?? ''"
        [email]="admin.email ?? ''"
        [phoneNumber]="admin.phoneNumber ?? ''"
        [regDate]="admin.registrationDateTime ?? ''"
        [roles]="admin.roles ?? []"
      ></app-user-card>
    </div>
  </ng-container>
</app-main-content-card>
